import React from 'react';
import { FileText, Loader2, RefreshCw, Clock, X } from 'lucide-react';
import {
  DocumentItem,
  DocumentIconWrapper,
  DocumentInfo,
  DocumentName,
  DocumentMeta,
  DocumentActions,
  StatusBadge,
  IconButton,
} from '../uploadDocuments.styles';

const DocumentListItem = ({ doc, onReupload, onSkip, disabled }) => {
  const { status, errorMessage } = doc;

  return (
    <DocumentItem>
      <DocumentIconWrapper>
        <FileText size={20} />
      </DocumentIconWrapper>

      <DocumentInfo>
        <DocumentName title={doc.name}>{doc.name}</DocumentName>
        <DocumentMeta>
          {doc.size}
          {doc.uploadedAt ? ` • ${doc.uploadedAt}` : ''}
          {(status === 'error' || status === 'size-error') && errorMessage
            ? ` • ${errorMessage}`
            : ''}
        </DocumentMeta>
      </DocumentInfo>

      <DocumentActions>
        {status === 'pending' && (
          <StatusBadge $status="PENDING">
            <Clock size={12} style={{ marginRight: 4 }} />
            Waiting
          </StatusBadge>
        )}

        {status === 'uploading' && (
          <StatusBadge $status="UPLOADING">
            <Loader2 size={12} className="spin" style={{ marginRight: 4 }} />
            Uploading
          </StatusBadge>
        )}

        {status === 'size-error' && (
          <>
            <StatusBadge $status="ERROR">File Too Large</StatusBadge>
            <IconButton
              onClick={() => onSkip(doc)}
              disabled={disabled}
              title="Skip this file"
              $variant="delete"
              aria-label={`Skip ${doc.name}`}
              type="button"
            >
              <X size={16} />
            </IconButton>
          </>
        )}

        {status === 'error' && (
          <>
            <StatusBadge $status="ERROR">Failed</StatusBadge>
            <IconButton
              onClick={() => onReupload(doc)}
              disabled={disabled}
              title="Retry upload"
              $variant="view"
              aria-label={`Retry upload for ${doc.name}`}
              type="button"
            >
              <RefreshCw size={16} />
            </IconButton>
            <IconButton
              onClick={() => onSkip(doc)}
              disabled={disabled}
              title="Skip this file"
              $variant="delete"
              aria-label={`Skip ${doc.name}`}
              type="button"
            >
              <X size={16} />
            </IconButton>
          </>
        )}

        {status === 'skipped' && (
          <StatusBadge $status="SKIPPED">
            <X size={12} style={{ marginRight: 4 }} />
            Skipped
          </StatusBadge>
        )}

        {status === 'done' && <StatusBadge $status="READY">READY</StatusBadge>}
      </DocumentActions>
    </DocumentItem>
  );
};

export default DocumentListItem;
